export default function CSVDataExportService($http, appSettings) {
  'ngInject';
  const baseUri = appSettings.InReachApiCSVExportEndpoint;
  const exportUri = baseUri + '/export';

  this.createCSV = function (csv) {
    if (!csv) {
      return;
    }
    var endpoint = baseUri;
    var req;
    if (csv) {
      req = {
        method: 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(csv.data)
      }; //end req
    }
    return $http(req);
  };

  this.updateCSV = function (csv) {
    var endpoint = exportUri + '/' + csv.id; // InReachApiSchedulerEndpoint
    let req = {
      method: 'PUT',
      url: endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(csv.data)
    }; //end req
    return $http(req);
  };

  this.getCSVs = function () {
    var endpoint = exportUri;
    return $http.get(endpoint);
  };

  this.getCSV = function (id) {
    var endpoint = exportUri + '/' + id;
    return $http.get(endpoint);
  };

  this.deleteCSV = function (csv) {
    if (!csv) return;
    var endpoint = exportUri + '/' + csv.id;
    return $http.delete(endpoint);
  };
}